import React from 'react';
import { DateFormat, ParticipantEmailEventViewModel } from 'stageclip-common';
import moment from 'moment-timezone';

import { callApi } from 'helpers/callApi/callApi';
import { AppTable, AppTableColumn } from 'components/table/appTable';
import Button from 'components/buttons/button';
import { EmailsLogTableProps, EmailsLogTableState } from './EmailsLogTable.types';

export class EmailsLogTable extends React.Component<EmailsLogTableProps, EmailsLogTableState> {
  columns: AppTableColumn[] = [
    {
      Header: 'Event type',
      accessor: (row: ParticipantEmailEventViewModel) => row.type[0].toUpperCase() + row.type.substring(1),
      className: 'break-words',
      id: 'type',
    },
    {
      Header: 'Participant',
      accessor: (row: ParticipantEmailEventViewModel) => row.participant.fullName,
      className: 'break-words',
      id: 'participantFullName',
    },
    {
      Header: 'Recipient email',
      accessor: (row: ParticipantEmailEventViewModel) => row.rcptTo,
      className: 'break-words',
      id: 'recipient',
    },
    {
      Header: 'Timestamp',
      accessor: (row: ParticipantEmailEventViewModel) => moment(row.timestamp).format(DateFormat.DateTime),
      className: 'break-words',
      id: 'timestamp',
    },
    {
      Header: 'Template',
      accessor: (row: ParticipantEmailEventViewModel) => row.templateId ?? '-',
      className: 'break-words',
      id: 'templateId',
    },
    {
      Cell: ({ value }: { value: ParticipantEmailEventViewModel }) => {
        const { openDetails } = this.props;
        const { data, type, timestamp } = value;

        return data ? <Button onClick={() => openDetails({ data, action: type, timestamp })} text="Details" /> : '-';
      },
      Header: 'Details',
      accessor: (row: ParticipantEmailEventViewModel) => row,
      id: 'details',
    },
  ];

  constructor(props: any) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      error: false,
    };
  }

  componentDidMount(): void {
    this.fetchEmailsLog();
  }

  fetchEmailsLog() {
    const { fetchEmailsLog, eventId } = this.props;

    callApi({
      action: () => {
        this.setState({ loading: true });

        return fetchEmailsLog(eventId);
      },
      onSuccess: ({ payload }) => {
        this.setState({ data: payload, loading: false });
      },
      onFailure: () => this.setState({ loading: false, error: true }),
    });
  }

  render() {
    const { data, loading, error } = this.state;

    return (
      <>
        {!!data && <AppTable tableName="EmailsLog" columns={this.columns} data={data} loading={loading} />}
        {error && <div>Something went wrong</div>}
      </>
    );
  }
}
